import React, { useMemo } from "react"
import {
    Box,
    Heading,
    Text,
    Divider,
    HStack,
    Center,
    Icon,
    BoxProps,
} from "@chakra-ui/react"
import { FiArrowUp } from "react-icons/fi"

import { getValidId } from "../shared/helpers"

const TableOfContents: React.FC<{
    content: string
    containerProps?: BoxProps
}> = ({ content, containerProps }) => {
    const data = JSON.parse(content)

    const headings = data?.content?.filter((item: any) =>
        item.nodeType.includes("heading")
    )

    const highestHeadingValue = useMemo(() => {
        let highest = 7
        headings?.forEach((heading: any) => {
            const headingValue = parseInt(heading.nodeType.split("-")[1])
            if (headingValue < highest) {
                highest = headingValue
            }
        })
        return highest
    }, [headings])

    const getIsHighestHeading = (heading: any) => {
        const headingValue = parseInt(heading.nodeType.split("-")[1])
        return headingValue === highestHeadingValue
    }

    return (
        <Box
            position="sticky"
            top="90px"
            h="fit-content"
            overflowY="auto"
            pr={0}
            pb={8}
            pt={4}
            mt={8}
            flexShrink={0}
            maxW="190px"
            minW="190px"
            {...containerProps}
        >
            <Heading size="sm">Table of Contents</Heading>
            <Divider variant={"gradient"} my={2} />
            {headings?.map((heading: any) => {
                const isHighestHeading = getIsHighestHeading(heading)
                const label = heading.content
                    // @ts-ignore
                    .map(h => h.value.replace("\r", "").replace("\n", ""))
                    .join("")

                if (label === "") return

                return (
                    <HStack
                        key={label}
                        as="a"
                        href={`#${getValidId(heading.content[0].value)}`}
                        _hover={{
                            textDecoration: "none",
                        }}
                        ml={isHighestHeading ? 0 : 2}
                        mb={2}
                        mt={isHighestHeading ? 4 : 1}
                    >
                        {" "}
                        <Box
                            minW="6px"
                            maxW="6px"
                            h="6px"
                            borderRadius="50%"
                            bg="gray.600"
                            mr={1}
                        />
                        <Text
                            fontSize={isHighestHeading ? "md" : "sm"}
                            color={isHighestHeading ? "brand.600" : "gray.600"}
                            fontWeight="bold"
                            noOfLines={1}
                        >
                            {label}
                        </Text>
                    </HStack>
                )
            })}
            <Center w="100%">
                <Center
                    as="a"
                    id={`blog-top-btn`}
                    href={`#blog-top`}
                    _hover={{
                        textDecoration: "none",
                        bg: "gray.100",
                    }}
                    mt={6}
                    bg="gray.50"
                    borderRadius="full"
                    w="120px"
                    h="40px"
                >
                    <Icon as={FiArrowUp} mr={1} />
                    <Text
                        fontSize="sm"
                        fontWeight="bold"
                        color="gray.600"
                        textAlign="center"
                    >
                        Back to Top
                    </Text>
                </Center>
            </Center>
        </Box>
    )
}

export default TableOfContents
